
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    }
  },
  id: '4f2263ad8d',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page support-page" data-name="support">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">Support</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="support-hero">\n                <div class="support-hero-illust">\n                    <i class="icon f7-icons if-not-md">headphones</i>\n                    <i class="icon material-icons md-only">support_agent</i>\n                </div>\n                <div class="support-hero-title">We\'re here to help</div>\n                <div class="support-hero-sub">Reach out anytime \u2014 our support team is happy to assist.</div>\n            </div>\n\n            <a href="tel:';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry && this.enquiry.phone', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.enquiry.phone, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '+917493939362';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" class="support-option link external" target="_system">\n                <div class="support-option-icon support-option-icon-green">\n                    <i class="icon f7-icons if-not-md">phone_fill</i>\n                    <i class="icon material-icons md-only">call</i>\n                </div>\n                <div class="support-option-body">\n                    <div class="support-option-title">Call us</div>\n                    <div class="support-option-sub">Speak to our support executive</div>\n                    <div class="support-option-meta">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry && this.enquiry.phone', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.enquiry.phone, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '+91 74939 39362';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n                </div>\n                <i class="icon f7-icons if-not-md support-option-arrow">chevron_right</i>\n                <i class="icon material-icons md-only support-option-arrow">chevron_right</i>\n            </a>\n\n            <a href="mailto:';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry && this.enquiry.email', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.enquiry.email, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'support@mdoc.in';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" class="support-option link external" target="_system">\n                <div class="support-option-icon support-option-icon-blue">\n                    <i class="icon f7-icons if-not-md">envelope_fill</i>\n                    <i class="icon material-icons md-only">mail</i>\n                </div>\n                <div class="support-option-body">\n                    <div class="support-option-title">Email us</div>\n                    <div class="support-option-sub">We usually reply within 24 hours</div>\n                    <div class="support-option-meta">';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry && this.enquiry.email', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.enquiry.email, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'support@mdoc.in';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n                </div>\n                <i class="icon f7-icons if-not-md support-option-arrow">chevron_right</i>\n                <i class="icon material-icons md-only support-option-arrow">chevron_right</i>\n            </a>\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.enquiry && this.enquiry.address', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="support-option">\n                <div class="support-option-icon support-option-icon-green">\n                    <i class="icon f7-icons if-not-md">placemark_fill</i>\n                    <i class="icon material-icons md-only">place</i>\n                </div>\n                <div class="support-option-body">\n                    <div class="support-option-title">Visit us</div>\n                    <div class="support-option-sub">Our office address</div>\n                    <div class="support-option-meta">';
          r += c(ctx_2.enquiry.address, ctx_2);
          r += '</div>\n                </div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <a href="/feedback/" class="support-option">\n                <div class="support-option-icon support-option-icon-orange">\n                    <i class="icon f7-icons if-not-md">chat_bubble_text_fill</i>\n                    <i class="icon material-icons md-only">forum</i>\n                </div>\n                <div class="support-option-body">\n                    <div class="support-option-title">Send feedback</div>\n                    <div class="support-option-sub">Tell us how we can improve</div>\n                </div>\n                <i class="icon f7-icons if-not-md support-option-arrow">chevron_right</i>\n                <i class="icon material-icons md-only support-option-arrow">chevron_right</i>\n            </a>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    